<template>
    <modal name="modal-quiz-offline"
           class="dd-m-modal dd-m-modal--quiz">

        <quiz-content-offline v-if="quiz" :data="quiz"></quiz-content-offline>

    </modal>
</template>
<script>
    import QuizContentOffline from '../quiz/quiz-content-offline'

    export default {
        name: 'modal-quiz-offline',
        components: {QuizContentOffline},
        data: () => {
            return {
                quiz: null
            }
        },
        mounted() {
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('openOfflineQuizModal', (msg, param) => {
                    window.scrollTo(0, 0);
                    this.quiz = param;
                    if (this.quiz) this.show();
                });

                PubSub.subscribe('closeOfflineQuizModal', () => this.hide());
            },
            show() {
                this.$modal.show('modal-quiz-offline');
            },
            hide() {
                this.$modal.hide('modal-quiz-offline');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/custom-modals/modal-quiz-offline.vue